export const convertWidthToPercent = (value: number) =>
  (value / window.innerWidth) * 100;
export const convertHeightToPercent = (value: number) =>
  (value / window.innerHeight) * 100;

export const consolePrint = function (...args: any[]) {
  queueMicrotask(console.log.bind(console, ...args));
};

/**
 * Yields to the main thread to allow the browser to perform other tasks
 */
export function yieldToMain() {
  if ("scheduler" in window && (window.scheduler as any).yield) {
    return (window.scheduler as any).yield();
  }

  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}
